import {createCachedColumnSelector} from './createCachedColumnSelector';

export const usePinnedLeftColumns = createCachedColumnSelector((col) => col.pinned === 'LEFT');
